import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AppStateModel, selectAppState } from '../../../app.state';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { areFeaturesEnabled, FeaturePermission } from '../../../../../../common/model/feature-permissions.enum';
import { Store } from '@ngxs/store';
import { RouteNavigationService } from '../route-navigation.service';
import { SubscriptionStatus } from '../../../../../../common/dto/subscription.dto';

export interface FeaturePermissionsRouteGuardData {
  requiredFeaturePermissions: FeaturePermission[];
}

@Injectable()
export class FeaturePermissionsRouteGuardLogic {
  constructor(
    private _store: Store,
    private _routeNavigationService: RouteNavigationService
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return selectAppState(this._store).pipe(
      filter((state: AppStateModel) => !!state?.isInitialized),
      take(1),
      map((applicationState: AppStateModel) => {
        const routeData: FeaturePermissionsRouteGuardData = <FeaturePermissionsRouteGuardData>route.data;

        const requiredFeaturePermissions = routeData.requiredFeaturePermissions;

        if (!requiredFeaturePermissions) {
          return false;
        }

        if (!applicationState.session?.permissions) {
          return false;
        }

        const hasPermission = areFeaturesEnabled(requiredFeaturePermissions, applicationState.session.permissions); // <-- here
        const session = this._store.selectSnapshot<AppStateModel>(
    (state) => state.appState
        ).session;

        if (!session) {
          return false;
        }
        if (session.subscription.status !== SubscriptionStatus.Active) {
          this._routeNavigationService.goToSubscriptionRequiredAsync();
        }

        if (!hasPermission) {
          this._routeNavigationService.goToSubscriptionRequiredAsync();
        }


        return hasPermission;
      }),
    );
  }
}

export const FeaturePermissionsRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  return inject(FeaturePermissionsRouteGuardLogic).canActivate(route);
};

